import { API_URL } from '@tg/app-core';
import { useSyncExternalStore } from 'react';

/* Есть ли связь с сервером. navigator.onLine говорит только про сеть устройства, поэтому
   учитываем и исход запросов: запрос не дошёл — связи нет; ответ пришёл — есть.
   Пока связи нет, раз в 5 с спрашиваем /health — как только ответит, связь вернулась. */

let online = typeof navigator === 'undefined' || navigator.onLine !== false;
const subs = new Set<() => void>();
let timer: ReturnType<typeof setTimeout> | undefined;

function set(v: boolean) {
  if (v === online) return;
  online = v;
  subs.forEach((f) => f());
  if (!v) schedule();
}

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(probe, 5000);
}

async function probe() {
  if (online) return;
  if (navigator.onLine === false) return schedule();
  try {
    const r = await fetch(API_URL + '/health', { cache: 'no-store' });
    if (r.ok) return set(true);
  } catch {
    /* не дошло */
  }
  schedule();
}

if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => set(false));
  window.addEventListener('online', () => probe());
  if (!online) schedule();
}

export const isOnline = () => online;
/** Запрос не дошёл до сервера */
export const reportNetFail = () => set(false);
/** Сервер ответил */
export const reportNetOk = () => set(true);
export function onNet(f: () => void) {
  subs.add(f);
  return () => {
    subs.delete(f);
  };
}
export const useOnline = () => useSyncExternalStore(onNet, isOnline);
